// Configurações centralizadas de ambiente do frontend

export const config = {
  apiBaseUrl: (process.env.VUE_APP_API_URL),
  // Configurações de ambiente
  isDevelopment: process.env.NODE_ENV !== 'production',
  isProduction: process.env.NODE_ENV === 'production'
}

// Função para obter a URL completa da API
export const getApiUrl = (endpoint = '') => {
  const baseUrl = config.apiBaseUrl
  const cleanEndpoint = `${endpoint}`.replace(/^\/+/, '')
  return cleanEndpoint ? `${baseUrl}/${cleanEndpoint}` : baseUrl
}

// Função para obter configurações de headers padrão
export const getDefaultHeaders = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json'
})

export default config
